import React, { createContext, useState, ReactElement, FC, useEffect } from "react";
import { CarriersuitesProductsType, WebSocketSubscribeMessageType, Prettify } from "../types";
import { useAxiosPrivate } from "../hooks";
import { Login } from "../pages";

type StaticDataType = undefined | {
  warehouse: {name:string, countryCode: string, currency:string, testMode:boolean},
  countries: {name:string, value:string, tradeArea: 'dom' | 'eu' | 'ex'}[],
  currencies: {name:string, value:string}[],
  deliveryTerms: {[version:string]: {name: string,value: string, freeTextPH?: string}[]},
  carriersuitesProducts: Prettify<CarriersuitesProductsType>,
  packageTypes: {name:string, value:string}[],
  notifications: Prettify<WebSocketSubscribeMessageType>[],
  tradingAccountTypes: {name:string, value:string}[],
  companyId: string,
}

type Props = {
  children: ReactElement
}

const StaticDataContext = createContext<{staticData: StaticDataType}>({} as {staticData: StaticDataType});

export const StaticDataProvider: FC<Props> = ({ children }) => {
  // get cookies and get language,  
  const api = useAxiosPrivate();
  const [ staticData, setStaticData ] = useState<StaticDataType>()

  useEffect(() => {
    api.get({endpoint: "/staticData", mount: {skeleton: true}})
      .then((response) => {
        setStaticData(response.data)
      })         
      .catch(e => {
        console.error("static failed:" , e)
      })
  }, [])

  return (
    <StaticDataContext.Provider value={{ staticData }}>
      {staticData ?
        children:
        <div />
      }      
    </StaticDataContext.Provider>
  )
}

export default StaticDataContext;
